  /* for customizer selection */

let obj={},productId;
let selector = {
  design_type:document.querySelectorAll('input[name="properties[Design Type]"]'),
  inputText:document.querySelectorAll('input.writable-input'),
  addToCart:document.querySelector('.custom-addTo-cart')
}


let customizeItem = (item) =>{
  item.forEach((subItem,index)=>{
    subItem.value = '';
  })
}

selector.design_type.forEach((item,index)=>{
  item.addEventListener('change',(evt)=>{
    let customize =  evt.target.id;
    let inputItem = document.querySelectorAll('.top--details input');
    customize == 'customize' ? (document.querySelector('.custom-addTo-cart').classList.remove('hidden'),document.querySelector('.addToCart').classList.add('hidden'),document.querySelector('.top--details').classList.remove('hidden')) : (document.querySelector('.custom-addTo-cart').classList.add('hidden'),document.querySelector('.addToCart').classList.remove('hidden'),document.querySelector('.top--details').classList.add('hidden'),customizeItem(inputItem));
  })
})
selector.inputText.forEach((item,index)=>{
  item.addEventListener('blur',(evt)=>{
    let input = evt.target;
    let inputValue = input.value;
    inputValue = inputValue.trim();
    inputValue.length > 0 ? obj[input.dataset.id]=1 : console.log("space");
  })
})

selector.addToCart.addEventListener('click',(evt)=>{
  let itemArray = [];
  let productQty = document.querySelector('.product-form__quantity .quantity__input').value;
  let uniqueId = getRandomInt(1, 100) + "_";
  uniqueId += Object.keys(obj).join('_');
  for(let i in obj){
    itemArray.push(
    {
      id:i,
      quantity:productQty,
      properties:{
        unique_id:uniqueId,
        addOns:'true'
        }
     }
    );
  }
  let formData ={
    items:itemArray
  };
    console.log(formData,uniqueId);
     fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      console.log(response.json());
      let form = document.querySelector('.custom_product-form');
      var newInput = document.createElement("input");

      // Set attributes for the new input (e.g., type, name, id)
      newInput.type = "hidden";
      newInput.name = "properties[unique_id]";
      newInput.value = uniqueId;
      // Append the new input to the form
      form.appendChild(newInput);
      document.querySelector('.addToCart').click();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
})
function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

/* file upload */
  
function previewFile(evt) {
    let img_product_id = evt.getAttribute('data-id');
    obj[img_product_id] = 1;
    console.log(obj);
    var front_img = document.querySelector('.custom-logo img');
    var shorts_img = document.querySelector('.custom-shorts-logo img');
    var preview = evt.parentNode.querySelector('img');
    var btn = evt.parentNode.querySelector('button');
    btn.innerText = "Change Image";
    var file = evt.files[0];
    var reader = new FileReader();

    reader.onloadend = function() {
        preview.src = reader.result;
        front_img.src = reader.result;
        shorts_img.src = reader.result;
    }

    if (file) {
        reader.readAsDataURL(file);
    } else {
        preview.src = "";
    }
    preview.classList.remove("hidden");
}